export default {
    "app.dashboard.analysis.timeLabel":"时间"
}